import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";

interface AgeConfirmModalProps {
  onConfirm: () => void;
}

export default function AgeConfirmModal({ onConfirm }: AgeConfirmModalProps) {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const confirmed = sessionStorage.getItem("ageConfirmed");
    if (confirmed === "true") {
      setVisible(false);
    }
  }, []);

  const handleConfirm = () => {
    sessionStorage.setItem("ageConfirmed", "true");
    setVisible(false);
    onConfirm();
  };

  const handleDeny = () => {
    window.location.href = "https://www.google.com";
  };

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="fixed inset-0 z-[9999] flex items-center justify-center bg-black/70 backdrop-blur-sm p-4"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.3 }}
        >
          <motion.div
            className="w-full max-w-md rounded-2xl border border-primary-400/30 bg-background-100/95 p-6 text-center shadow-2xl"
            initial={{ scale: 0.85, opacity: 0, y: 30 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            exit={{ scale: 0.9, opacity: 0, y: 20 }}
            transition={{ type: "spring", stiffness: 350, damping: 25 }}
          >
            <motion.div
              className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-500/20"
              animate={{ scale: [1, 1.05, 1] }}
              transition={{ repeat: Infinity, duration: 2, ease: "easeInOut" }}
            >
              <span className="text-3xl">18</span>
            </motion.div>
            <h2 className="mb-2 text-2xl font-bold text-foreground-50">
              年齢確認
            </h2>
            <p className="mb-6 text-sm leading-relaxed text-foreground-300">
              このウェブサイトには成人向けコンテンツが含まれています。18歳未満の方はアクセスできません。あなたは18歳以上ですか？
            </p>
            <div className="flex flex-col gap-3 sm:flex-row">
              <motion.button
                onClick={handleDeny}
                className="flex-1 rounded-xl border border-foreground-600/30 px-5 py-3 text-sm font-medium text-foreground-400 cursor-pointer"
                whileHover={{ scale: 1.02, backgroundColor: "oklch(var(--background-200))" }}
                whileTap={{ scale: 0.97 }}
              >
                いいえ、18歳未満です
              </motion.button>
              <motion.button
                onClick={handleConfirm}
                className="flex-1 rounded-xl bg-primary-500 px-5 py-3 text-sm font-bold text-white cursor-pointer"
                whileHover={{ scale: 1.03 }}
                whileTap={{ scale: 0.95 }}
              >
                はい、18歳以上です
              </motion.button>
            </div>
            <p className="mt-4 text-xs text-foreground-700">
              18歳未満の方の閲覧は法律で禁止されています
            </p>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}